var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirmachain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "75px",
    viewBox: "0 0 75 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Logo/Firmachain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Logo/Firmachain",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "white_logo",
    transform: "translate(12.000000, 8.000000)",
    fill: "#C1C1D3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "25.3645313 42.0717838 24.1214063 41.359 24.1214063 28.8254865 30.4039688 25.2185135 25.3645313 22.3243243 19.125 25.908973 19.125 44.2755135 25.3645313 47.8378378 41.4375 38.6434054 36.55425 35.6599189"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "26.0689687 0 0 14.4837027 0 43.4941622 4.9629375 46.2432432 4.9629375 17.294973 26.0689687 5.55556757 35.5740937 10.8575946 36.6578437 5.87927027"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "9.5625 20.3215135 9.5625 49.8390541 25.41075 59 51 44.2069459 51 14.624027 46.1295 17.4735676 46.1295 41.3382703 25.41075 53.3264324 14.4345937 46.9703784 14.4345937 23.1933784 25.41075 16.8373243 36.3869063 23.1710541 41.2574063 20.3645676 41.2574063 20.3215135 25.41075 11.1621622"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmachain);
export default __webpack_public_path__ + "static/media/firmachain.a34046991a7478a8f05486431db72444.svg";
export { ForwardRef as ReactComponent };